import { render } from "./UiMobileDropdownFilter.vue?vue&type=template&id=3524b644&scoped=true&ts=true"
import script from "./UiMobileDropdownFilter.vue?vue&type=script&lang=ts"
export * from "./UiMobileDropdownFilter.vue?vue&type=script&lang=ts"

import "./UiMobileDropdownFilter.vue?vue&type=style&index=0&id=3524b644&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3524b644"]])

export default __exports__